"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hash_utils_1 = require("./hash-utils");
var createKeccakHash = require("keccak");
exports.keccak224 = hash_utils_1.createHashFunction(function () {
  return createKeccakHash("keccak224");
});
exports.keccak256 = hash_utils_1.createHashFunction(function () {
  return createKeccakHash("keccak256");
});
exports.keccak384 = hash_utils_1.createHashFunction(function () {
  return createKeccakHash("keccak384");
});
exports.keccak512 = hash_utils_1.createHashFunction(function () {
  return createKeccakHash("keccak512");
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTtBQUVBLElBQU1BLGdCQUFnQixHQUFHQyxPQUFPLENBQUMsUUFBUSxDQUFDO0FBRTdCQyxpQkFBUyxHQUFHQywrQkFBa0IsQ0FBQztFQUMxQyx1QkFBZ0IsQ0FBQyxXQUFXLENBQUM7QUFBN0IsQ0FBNkIsQ0FDOUI7QUFFWUQsaUJBQVMsR0FBR0MsK0JBQWtCLENBQUM7RUFDMUMsdUJBQWdCLENBQUMsV0FBVyxDQUFDO0FBQTdCLENBQTZCLENBQzlCO0FBRVlELGlCQUFTLEdBQUdDLCtCQUFrQixDQUFDO0VBQzFDLHVCQUFnQixDQUFDLFdBQVcsQ0FBQztBQUE3QixDQUE2QixDQUM5QjtBQUVZRCxpQkFBUyxHQUFHQywrQkFBa0IsQ0FBQztFQUMxQyx1QkFBZ0IsQ0FBQyxXQUFXLENBQUM7QUFBN0IsQ0FBNkIsQ0FDOUIiLCJuYW1lcyI6WyJjcmVhdGVLZWNjYWtIYXNoIiwicmVxdWlyZSIsImV4cG9ydHMiLCJoYXNoX3V0aWxzXzEiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL2tlY2Nhay50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==